module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-help3D-button",
      "title": "Help Navigazione 3D"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-751fa075!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/Help3D.vue
// module id = 886
// module chunks = 39